export default __webpack_public_path__ + "static/map-7f5a3029a5c7dd955ef4ebc2608149a5.png";